import lodash from 'lodash';

function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

function uuid() {
    return Date.now() + '_' + S4()
}

function deepClone(object) {
    return lodash.cloneDeep(object);
}

export {
    deepClone,
    uuid,
    S4
}